<template>
  <b-navbar toggleable="md" type="light" variant="link" class="site-header" sticky>
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand :to="{ name: 'dashboard'}">
      <Logo width="85" height="34" class="shadow-lg"></Logo>
    </b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <!-- <b-nav-item :to="{ name: 'dashboard'}">Dashboard</b-nav-item> -->
        <b-nav-item :to="{ name: 'tests'}" v-if="isRoutingToolEditor()">Tests</b-nav-item>
        <b-nav-item :to="{ name: 'competitorLeader'}" v-if="isCompetitorAnalyst()">Competitor Analysis</b-nav-item>
        <b-nav-item :to="{ name: 'content'}" v-if="isWebEditor()">Web Content</b-nav-item>
        <b-nav-item :to="{ name: 'config'}" v-if="isWebEditor()">Web Config</b-nav-item>
        <b-nav-item :to="{ name: 'cms'}" v-if="isCmsEditor()">CMS</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right id="header-user-info" :text=greeting() variant="link">
          <b-dropdown-item :to="{ name: 'logout'}" class="text-danger">Logout</b-dropdown-item>
          <b-dropdown-item>
            <small>Env: {{env}}</small>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Logo from '@/components/Logo.vue'
export default {
  name: 'Header',
  components: {
    Logo
  },
  mounted () {
    this.$store.dispatch('user/getUser')
  },
  computed: {
    ...mapState({
      user: 'user'
    }),
    ...mapGetters({
      isRoutingToolEditor: 'auth/isRoutingToolEditor',
      isCompetitorAnalyst: 'auth/isCompetitorAnalyst',
      isWebEditor: 'auth/isWebEditor',
      isCmsEditor: 'auth/isCmsEditor'
    })
  },
  methods: {
    greeting () {
      return 'Hi, ' + this.user.name
    }
  },
  data () {
    return {
      env: process.env.NODE_ENV
    }
  }
}
</script>

<style lang="scss" scoped>
.site-header {
  background-color: rgba(255, 255, 255, 1);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  box-shadow: inset 0 -1px 0 0 #DDDDDD;
}
small{
  font-size: 70%;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue